/* Profit Margin Calculator Logic — Math, Charts & CSV Export */

let pmDonutChart = null;
let pmGrowthChart = null;

function getPmInputs() {
  const getVal = (id, def = 0) => {
    const el = document.getElementById(id);
    if (!el) return def;
    const v = +el.value;
    return isNaN(v) ? def : v;
  };

  return {
    revenue: getVal('pmRevenue', 1000000),
    cogs: getVal('pmCogs', 400000),
    opex: getVal('pmOpex', 200000),
    taxInt: getVal('pmTaxInt', 50000),
  };
}

function updatePmUrlParams(params) {
  try {
    const url = new URL(window.location);
    url.searchParams.set('revenue', params.revenue);
    url.searchParams.set('cogs', params.cogs);
    url.searchParams.set('opex', params.opex);
    url.searchParams.set('taxInt', params.taxInt);
    window.history.replaceState({}, '', url);
  } catch (e) {}
}

function parsePmUrlParams() {
  const searchParams = new URLSearchParams(window.location.search);
  const getNum = (key) => {
    const val = searchParams.get(key);
    return val !== null ? +val : null;
  };

  return {
    revenue: getNum('revenue'),
    cogs: getNum('cogs'),
    opex: getNum('opex'),
    taxInt: getNum('taxInt'),
  };
}

function calculatePm(params) {
  const { revenue, cogs, opex, taxInt } = params;

  const grossProfit = revenue - cogs;
  const grossMargin = revenue > 0 ? (grossProfit / revenue) * 100 : 0;

  const operatingProfit = grossProfit - opex; // EBIT
  const operatingMargin = revenue > 0 ? (operatingProfit / revenue) * 100 : 0;

  const netProfit = operatingProfit - taxInt;
  const netMargin = revenue > 0 ? (netProfit / revenue) * 100 : 0;

  const totalCosts = cogs + opex + taxInt;
  const markupPercent = totalCosts > 0 ? (netProfit / totalCosts) * 100 : 0;

  const items = [
    { name: 'Total Revenue', value: revenue, share: 100 },
    { name: 'Cost of Goods Sold (COGS)', value: cogs, share: revenue > 0 ? (cogs / revenue) * 100 : 0 },
    { name: 'Gross Profit', value: grossProfit, share: revenue > 0 ? (grossProfit / revenue) * 100 : 0 },
    { name: 'Operating Expenses (OpEx)', value: opex, share: revenue > 0 ? (opex / revenue) * 100 : 0 },
    { name: 'Operating Profit (EBIT)', value: operatingProfit, share: revenue > 0 ? (operatingProfit / revenue) * 100 : 0 },
    { name: 'Taxes & Interest', value: taxInt, share: revenue > 0 ? (taxInt / revenue) * 100 : 0 },
    { name: 'Net Profit', value: netProfit, share: revenue > 0 ? (netProfit / revenue) * 100 : 0 },
  ];

  return {
    revenue: Math.round(revenue),
    cogs: Math.round(cogs),
    opex: Math.round(opex),
    taxInt: Math.round(taxInt),
    grossProfit: Math.round(grossProfit),
    grossMargin: +grossMargin.toFixed(2),
    operatingProfit: Math.round(operatingProfit),
    operatingMargin: +operatingMargin.toFixed(2),
    netProfit: Math.round(netProfit),
    netMargin: +netMargin.toFixed(2),
    markupPercent: +markupPercent.toFixed(2),
    items,
  };
}

function updateDisplays(params) {
  const setTxt = (id, txt) => {
    const el = document.getElementById(id);
    if (el) el.textContent = txt;
  };

  setTxt('pmRevenueDisplay', fmt(params.revenue));
  setTxt('pmCogsDisplay', fmt(params.cogs));
  setTxt('pmOpexDisplay', fmt(params.opex));
  setTxt('pmTaxIntDisplay', fmt(params.taxInt));
}

function renderPmResults(result, params) {
  const setTxt = (id, txt) => {
    const el = document.getElementById(id);
    if (el) el.textContent = txt;
  };

  setTxt('pmVerdictHeadline', `Gross Margin: ${result.grossMargin}% | Net Margin: ${result.netMargin}%`);
  setTxt('pmVerdictDetail', `Your business achieves ${fmt(result.netProfit)} net profit on ${fmt(params.revenue)} revenue (${result.netMargin}% net profit margin, ${result.markupPercent}% cost markup).`);

  setTxt('pmGrossProfitStatValue', fmt(result.grossProfit));
  setTxt('pmNetProfitStatValue', fmt(result.netProfit));
  setTxt('pmGrossMarginMetricValue', `${result.grossMargin}%`);
  setTxt('pmOpMarginMetricValue', `${result.operatingMargin}%`);
  setTxt('pmNetMarginMetricValue', `${result.netMargin}%`);

  renderTable(result.items);

  try {
    if (typeof Chart !== 'undefined') {
      renderDonutChart(params.cogs, params.opex, params.taxInt, Math.max(0, result.netProfit));
      renderGrowthChart(result.grossMargin, result.operatingMargin, result.netMargin);
    }
  } catch (err) {
    console.warn('Profit Margin Chart rendering error:', err);
  }
}

function renderDonutChart(cogs, opex, taxInt, netProfit) {
  const ctx = document.getElementById('pmDonutChart');
  if (!ctx) return;

  if (pmDonutChart) pmDonutChart.destroy();

  pmDonutChart = new Chart(ctx, {
    type: 'doughnut',
    data: {
      labels: ['Direct COGS', 'Operating Expenses', 'Tax & Interest', 'Net Profit'],
      datasets: [
        {
          data: [cogs, opex, taxInt, netProfit],
          backgroundColor: [cssVar('--chart-rent'), '#F59E0B', '#EC4899', cssVar('--chart-buy')],
          borderColor: cssVar('--bg-card'),
          borderWidth: 3,
          hoverOffset: 4,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: { color: cssVar('--chart-tick'), usePointStyle: true, pointStyle: 'circle', padding: 12 },
        },
        tooltip: {
          backgroundColor: cssVar('--tooltip-bg'),
          borderColor: cssVar('--tooltip-border'),
          borderWidth: 1,
          titleColor: cssVar('--tooltip-title'),
          bodyColor: cssVar('--tooltip-body'),
          callbacks: {
            label: (ctx) => `${ctx.label}: ${fmt(ctx.raw)}`,
          },
        },
      },
      cutout: '72%',
    },
  });
}

function renderGrowthChart(grossMargin, opMargin, netMargin) {
  const ctx = document.getElementById('pmGrowthChart');
  if (!ctx) return;

  if (pmGrowthChart) pmGrowthChart.destroy();

  pmGrowthChart = new Chart(ctx, {
    type: 'bar',
    data: {
      labels: ['Profitability Margins'],
      datasets: [
        {
          label: 'Gross Margin %',
          data: [grossMargin],
          backgroundColor: '#3B82F6',
          borderRadius: 6,
        },
        {
          label: 'Operating Margin %',
          data: [opMargin],
          backgroundColor: '#F59E0B',
          borderRadius: 6,
        },
        {
          label: 'Net Margin %',
          data: [netMargin],
          backgroundColor: cssVar('--chart-buy'),
          borderRadius: 6,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'top',
          align: 'end',
          labels: { color: cssVar('--chart-tick'), usePointStyle: true, pointStyle: 'circle', padding: 16 },
        },
        tooltip: {
          backgroundColor: cssVar('--tooltip-bg'),
          borderColor: cssVar('--tooltip-border'),
          borderWidth: 1,
          titleColor: cssVar('--tooltip-title'),
          bodyColor: cssVar('--tooltip-body'),
          callbacks: {
            label: (ctx) => `${ctx.dataset.label}: ${ctx.raw}%`,
          },
        },
      },
      scales: {
        x: {
          grid: { color: cssVar('--chart-grid') },
          ticks: { color: cssVar('--chart-tick') },
        },
        y: {
          grid: { color: cssVar('--chart-grid') },
          ticks: {
            color: cssVar('--chart-tick'),
            callback: (v) => `${v}%`,
          },
        },
      },
    },
  });
}

function renderTable(items) {
  const tbody = document.getElementById('pmScheduleBody');
  if (!tbody) return;

  tbody.innerHTML = items.map((row) => {
    const isProfit = row.name.includes('Profit');
    const isLoss = row.value < 0;

    return `
      <tr ${isProfit ? 'style="background: var(--bg-surface); font-weight: 600;"' : ''}>
        <td>${row.name}</td>
        <td class="${isLoss ? 'advantage-renter' : isProfit ? 'advantage-buy' : ''}">${fmt(row.value)}</td>
        <td>${row.share.toFixed(1)}%</td>
      </tr>
    `;
  }).join('');
}

function exportPmCsv() {
  const params = getPmInputs();
  const result = calculatePm(params);
  const headers = ['Financial Line Item', 'Amount', 'Share of Revenue'];
  const rows = result.items.map((r) => [r.name, r.value, `${r.share.toFixed(1)}%`]);

  const csv = [headers, ...rows].map((r) => r.join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `profit-margin-analysis.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
}

function applyPmCountryRanges(country, overrideParams = {}) {
  if (!country) return;
  const curr = country.currency || 'USD';

  let defaultRevenue = 1000000;

  if (curr === 'INR') {
    defaultRevenue = 1000000;
  } else if (curr === 'JPY') {
    defaultRevenue = 10000000;
  }

  const inputs = [
    { id: 'pmRevenue', val: overrideParams.revenue ?? defaultRevenue },
    { id: 'pmCogs', val: overrideParams.cogs },
    { id: 'pmOpex', val: overrideParams.opex },
    { id: 'pmTaxInt', val: overrideParams.taxInt },
  ];

  inputs.forEach((s) => {
    const el = document.getElementById(s.id);
    if (el && s.val !== null) {
      el.value = s.val;
    }
  });
}

function recalculatePm() {
  const params = getPmInputs();
  updateDisplays(params);
  updatePmUrlParams(params);
  const result = calculatePm(params);
  renderPmResults(result, params);
}

function initPmCalculator() {
  if (!document.getElementById('pmRevenue')) return;

  const urlParams = parsePmUrlParams();

  initCountry((country) => {
    applyPmCountryRanges(country, urlParams);
    recalculatePm();
  });

  const inputs = ['pmRevenue', 'pmCogs', 'pmOpex', 'pmTaxInt'];
  inputs.forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.addEventListener('input', recalculatePm);
      el.addEventListener('change', recalculatePm);
    }
  });

  const exportBtn = document.getElementById('exportPmCsv');
  if (exportBtn) {
    exportBtn.addEventListener('click', exportPmCsv);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initPmCalculator();
});
